import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewsubmissioncontainer',
  templateUrl: './viewsubmissioncontainer.component.html',
  styleUrls: ['./viewsubmissioncontainer.component.scss']
})
export class ViewsubmissioncontainerComponent implements OnInit {

  viewtype:any;
  constructor() { }

  ngOnInit() {
  }

  btnDASubmissions()
  {
    this.viewtype="DASubmissions";
  }
  btnDAImport()
  {
    this.viewtype="DAImport";
  }
  btnDocuments()
  {
    this.viewtype="Documents";
  }

}
